import {
  LOAD_RESERVATION_REVIEW_FOR_ADMIN,
  DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN,
  UPDATE_SQUAD_QTY_FOR_ADMIN,
  UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN,
  UPDATE_CART_TOTAL_FOR_ADMIN,
  PROCESSING_STARTED,
  PROCESSING_FINISHED
} from './constants';

const initialState = {
  cart: null,
  total: 0,
  processing: false,
  amount: 0,
  description: '',
  showClearCartConfirmation: false
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN: {
      return {
        ...state,
        showClearCartConfirmation: payload
      };
    }

    case LOAD_RESERVATION_REVIEW_FOR_ADMIN: {
      let cart = payload;
      let squadsInCart = cart.squads,
        virtualEventsInCart = cart.virtualEvents;
      let eventsInCart = cart.squads.concat(cart.virtualEvents.filter(virtualEvent => virtualEvent.eventId));
      
      eventsInCart.forEach(event => {
        if (cart.squads.length && !event.eventNumberOfBowlers) {
          event.eventNumberOfBowlers = eventsInCart.find(innerEvent => innerEvent.eventNumberOfBowlers && innerEvent.eventId === event.eventId).eventNumberOfBowlers;
        }
      });

      let bowlerOwnedVirtualEvents = cart.virtualEvents.filter(virtualEvent => !virtualEvent.eventId);

      const total = squadsInCart.reduce((a, b) => a + b.eventTotalPrice * b.quantity, 0)
        + virtualEventsInCart.reduce((a, b) => a + b.price * b.quantity, 0);

      return {
        ...state,
        ...{
          cart: cart,
          total: total,
          amount: total.toFixed(2).replace(/\./,''),
          description: squadsInCart.map(item => item.summary).join(','),
          eventsInCart: eventsInCart,
          bowlerOwnedVirtualEvents: bowlerOwnedVirtualEvents
        }
      };
    }

    case UPDATE_CART_TOTAL_FOR_ADMIN: {
      let squadsInCart = state.cart.squads,
        virtualEventsInCart = state.cart.virtualEvents;
      const total = squadsInCart.reduce((a, b) => a + b.eventTotalPrice * b.quantity, 0)
        + virtualEventsInCart.reduce((a, b) => a + b.price * b.quantity, 0);

      let eventsInCart = squadsInCart.concat(virtualEventsInCart.filter(virtualEvent => virtualEvent.eventId));
      let bowlerOwnedVirtualEvents = virtualEventsInCart.filter(virtualEvent => !virtualEvent.eventId);

      return {
        ...state,
        eventsInCart: eventsInCart,
        bowlerOwnedVirtualEvents: bowlerOwnedVirtualEvents,
        total
      };
    }

    case UPDATE_SQUAD_QTY_FOR_ADMIN:
      return {
        ...state,
        cart: {
          ...state.cart,
          squads: state.cart.squads.map(x => squadReducer(x, {type, payload}))
        }
      };

    case UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN:
      return {
        ...state,
        cart: {
          ...state.cart,
          virtualEvents: state.cart.virtualEvents.map(x => virtualEventReducer(x, {type, payload}))
        }
      };
    case PROCESSING_STARTED:
      return {
        ...state,
        processing: true
      };
    case PROCESSING_FINISHED:
      return {
        ...state,
        processing: false
      };
    default:
      return state;
  }
};

const squadReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case UPDATE_SQUAD_QTY_FOR_ADMIN: {
      if (state.id !== payload.squadId) {
        return state;
      }
                 
      let newQty = Number(payload.inputValue || 0);
      let adminAvailable = state.adminAvailable;
      let quantity = state.quantity;

      if (newQty > payload.max) {
        newQty = payload.max;
      }
      else if (newQty < 0) {
        newQty = 0;
      }

      return {
        ...state,
        quantity: newQty
        //adminAvailable: adminAvailable - quantity
      };
    }

    default:
      return state;
  }
};

const virtualEventReducer = (state = {}, {type, payload}) => {
  switch (type) {
    case UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN:
      return state.id === payload.virtualEventId
        ? {
          ...state,
          quantity: Number(payload.inputValue)
        }
        : state;

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/review/reducer.js